import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@windmill/react-ui';
import { FormattedMessage } from 'react-intl';

const COMPONENT_ID = 'teacher-class-checklist-modal';

interface CheckListModalProps {
    checkListModalOpen: boolean
    onClose: () => void
}

export default function CheckListModal({
                    checkListModalOpen,
                    onClose }: CheckListModalProps) {
  return (
    <Modal isOpen={checkListModalOpen} onClose={onClose} style={{ margin: 'auto' }} id={COMPONENT_ID}>
      <ModalHeader>
        <FormattedMessage id="check-list" />
      </ModalHeader>
      <ModalBody>
        <h1><FormattedMessage id="check-list-title-overview" /></h1>
        <ul className="list-decimal ml-8">
          <li className="mb-1"><FormattedMessage id="check-list-point1-overview" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point2-overview" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point3-overview" /></li>
        </ul>
        <h1><FormattedMessage id="check-list-title-start" /></h1>
        <ul className="list-decimal ml-8">
          <li className="mb-1"><FormattedMessage id="check-list-point1-start" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point2-start" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point3-start" /></li>
        </ul>
        <h1><FormattedMessage id="check-list-title-mid" /></h1>
        <ul className="list-decimal ml-8">
          <li className="mb-1"><FormattedMessage id="check-list-point1-mid" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point2-mid" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point3-mid" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point4-mid" /></li>
        </ul>
        <h1><FormattedMessage id="check-list-title-end" /></h1>
        <ul className="list-decimal ml-8">
          <li className="mb-1"><FormattedMessage id="check-list-point1-end" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point2-end" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point3-end" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point4-end" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point5-end" /></li>
          <li className="mb-1"><FormattedMessage id="check-list-point6-end" /></li>
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button className="w-full sm:w-auto" onClick={onClose}>
          <FormattedMessage id="close" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
